export default "__VITE_ASSET__bJCBzCBp__"